export default __webpack_public_path__ + "assets/images/7b991f093eda90a03a7752108e3307bd.png";